import React, { useState, useEffect, useContext } from 'react';
import './authentication.css'; // Import your CSS file
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Modal } from 'antd';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import SMO_Agreement from '../../Assets/SMO_Agreement.pdf';
import axios from 'axios';
import Swal from 'sweetalert2';
import UserContext from "../../Context/User/userContext";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckCircleOutlined, FileUploadOutlined } from '@mui/icons-material';

const steps = [
  {
    label: 'Download Agreement',
    description: `please download our agreement by clicking this.`,
    icon: <FileDownloadOutlinedIcon />,
  },
  {
    label: 'Upload Agreement',
    description: 'Kindly upload your documents correctly for verification to continue with the authentication process.',
    icon: <FileUploadOutlinedIcon />,
  },
  {
    label: 'Authenticate',
    description: `Please authenticate this document for verification. Once reviewed, if it meets our requirements, we will notify you via email regarding your eligibility for our portal..`,
    icon: <GppGoodOutlinedIcon />,

  },
];

function AuthenticateUser({ setShowSpinner }) {
  const navigate = useNavigate()
  const location = useLocation()
  // //Bearer Token
  // const token = localStorage.getItem('token');
  // const tokenValue = token ? token.slice(1, token.length - 1) : "";
  // // User Object
  // const userObj = localStorage.getItem('user');
  // const user = userObj ? JSON.parse(userObj) : "";

  // User Object
  const { user, setUser } = useContext(UserContext);
  const userObj = user && (typeof user == "string" ? JSON.parse(user) : user);
  //Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : "";

  const authenticateUser = () => {
    axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/user?id=${userObj._id}`, {
      headers: {
        'Authorization': `Bearer ${tokenValue}`
        // You can add other headers if needed like authorization token, etc.
      }
    })
      .then(res => {
        const { approvedByAdmin, signedDocument } = res.data.user;
        axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/validateAdmin/${userObj._id}`, {
          headers: {
            'Authorization': `Bearer ${tokenValue}`
            // You can add other headers if needed like authorization token, etc.
          }
        })
          .then(res => {
            const adminExist = res.data.success;
            if (adminExist) {
              console.log('adminExist')
              navigate("/home")
            } else if (approvedByAdmin && location.pathname === '/authentication') {
              console.log("approvedByAdmin && location.pathname === '/authentication'")
              navigate("/home")
            } else if (signedDocument !== "" && !approvedByAdmin && location.pathname === '/authentication') {
              console.log(signedDocument, 'signedDocument !== "" && !approvedByAdmin && location.pathname === "/authentication"')
              navigate("/");
            }
          })
          .catch(error => {
            console.error("Error:", error.response.data.message);
          });

      })
      .catch(error => {
        console.error("Error:", error.response?.data?.message);
      });
  }

  useEffect(() => {
    if (user) {
      authenticateUser()
    }
  }, [user])

  const [activeStep, setActiveStep] = useState(0);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [fileValue, setFileValue] = useState(null);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleUpload = () => {
    setOpenUploadModal(true);
  };

  const handleCloseUploadModal = () => {
    setOpenUploadModal(false);
  };

  const handleAuthenticate = () => {
    setShowSpinner(true);
    // Assuming 'file' is the file object obtained from the input element
    const formData = new FormData();
    formData.append('file', fileValue); // 'image' should be the key expected by your backend for the file

    if (fileValue.type === 'application/pdf') {
      // Prepare the URL with query parameters
      const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/auth/uploadDocument?name=${userObj._id}`;


      // Make the API request using Axios
      axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${tokenValue}`
          // You can add other headers if needed like authorization token, etc.
        }
      })
        .then(res => {
          // Handle success
          setShowSpinner(false);
          // Perform actions like showing a success message, updating state, etc.
          Swal.fire({
            title: "Document Recieved!",
            text: "Your documents have been recived wait till admin approve your document",
            icon: "success",
            customClass: {
              container: 'swal2-container-custom'
            }
          })
          localStorage.clear();
          setUser("");
          // Ensure navigation occurs regardless of how the modal is closed
          navigate("/");
        })
        .catch(error => {
          // Handle error
          // Show error message to user or retry logic
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
            customClass: {
              container: 'swal2-container-custom'
            }
          });
        })
        .finally(() => {
          setShowSpinner(false);
        })
    } else {
      // Handle error
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'File type should be a pdf',
        customClass: {
          container: 'swal2-container-custom'
        }
      });
    }
  }

  return (
    <div className='main-div'>
      <h1 style={{ color: '#169a8f', lineHeight: 1.2 }}>
        Research Mate <br />
        SMO Agreement <br />
        Authentication <br />
      </h1>
      <div className="item-hints">
        <div className="hint" data-position="4">
          <span className="hint-radius"></span>
          <span className="hint-dot">Tip</span>
          <div className="hint-content do--split-children">
            <p>After completing these steps, we will review your document. If it meets our requirements, you will receive an email notification.</p>
            <h3>Please Do these Steps to continue with Research Mate</h3>
          </div>
        </div>
      </div>
      <div className='steppers'>
        <Box sx={{ width: '450px' }}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel
                  optional={
                    index === 2 ? (
                      <Typography variant="caption">Last step</Typography>
                    ) : null
                  }
                  icon={step.icon ? React.cloneElement(step.icon, { fontSize: '70px', fontWeight: 'bold' }) : null}
                  sx={{ fontSize: '24px', color: '#169a8f', fontWeight: 'bold' }}
                >
                  <h2 style={{ color: '#169a8f',fontFamily:'nunito' }}>{step.label}</h2>
                </StepLabel>

                <StepContent>
                  <Typography>{step.description}</Typography>
                  {index === 0 && (
                    <a href={SMO_Agreement} download={'SMO_Agreement'}>
                      <Button
                        variant="contained"
                        onClick={handleNext}
                        sx={{ mt: 1, mr: 1, backgroundColor: '#169a8f', fontSize: '12px' }}
                      >
                        Download &nbsp; &nbsp; <FileDownloadOutlinedIcon />
                      </Button>
                    </a>
                  )}
                  {index === 1 && (
                    <div>
                      <Button
                        variant="contained"
                        onClick={handleUpload}
                        sx={{ mt: 1, mr: 1, backgroundColor: '#169a8f', fontSize: '12px' }}
                      >
                        Upload Agreement &nbsp; &nbsp;<FileUploadOutlinedIcon />
                      </Button>

                    </div>
                  )}
                  <Box sx={{ mb: 2 }}>
                    <div>

                      {index === steps.length - 1 ? (
                        <Button
                          variant="contained"
                          onClick={() => {
                            handleNext()
                            handleAuthenticate()
                          }}
                          sx={{ mt: 1, mr: 1, backgroundColor: '#169a8f', fontSize: '12px' }}
                        >

                          Authenticate &nbsp; &nbsp;
                          <GppGoodOutlinedIcon style={{ marginRight: '8px' }} />
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          onClick={() => handleNext()}
                          sx={{ mt: 1, mr: 1, backgroundColor: '#169a8f', fontSize: '12px' }}
                        >
                          Continue
                        </Button>
                      )}
                      <Button
                        disabled={index === 0}
                        onClick={handleBack}
                        sx={{ mt: 1, mr: 1 }}
                      >
                        <ArrowBackIosOutlinedIcon style={{ color: '#169a8f', fontSize: '24px', fontWeight: 'bolder' }} />
                      </Button>
                    </div>
                  </Box>
                </StepContent>
              </Step>
            ))
            }
          </Stepper >
        </Box >
      </div >
      <Modal
  className="red-title-modal custom-border-modal"
  title="Upload Agreement"
  visible={openUploadModal}
  onCancel={handleCloseUploadModal}
  footer={null} // Removes footer buttons
>
  <div className='justify-content-between mt-3' style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <input
      type="file"
      placeholder="Upload Agreement"
      onChange={e => setFileValue(e.target.files[0])}
      style={{ padding: '10px', fontSize: '16px' }} // Style input for better appearance
    />
    <FileUploadOutlined
      onClick={() => {
        if (!fileValue) {  // Check if file is selected
          Swal.fire({
            icon: 'error',
            title: 'Oops!',
            text: 'Please upload a file before proceeding.',
            confirmButtonText: 'OK'
          });  // Show sweetalert error if no file uploaded
        } else {
          handleCloseUploadModal();  // Close modal if file uploaded
        }
      }}
      style={{
        cursor: 'pointer', 
        fontSize: '30px', 
        fontWeight: 'bolder', 
        marginRight: '10px',
        color: '#178383'
      }} 
    />
  </div>
</Modal>
      {/* <Modal
        className="red-title-modal custom-border-modal "
        title="Upload Agreement"
        visible={openUploadModal}
        onCancel={handleCloseUploadModal}
        footer={null} // Remove footer buttons
      >
        <input
          type='file'
          placeholder='Upload Agreement <FileUploadOutlinedIcon />'
          onChange={e => setFileValue(e.target.files[0])}
        />
      </Modal> */}
    </div >
  );
}

export default AuthenticateUser;
